import { Button } from "components/Button/Button";
import NotFound from "components/not-found/NotFound";
import useFullPageLoader from "hooks/useFullPageLoader";
import useMuiButtonLoader from "hooks/useMuiButtonLoader";
import React, { useState } from "react";
import { toast } from "react-hot-toast";
import Pagination from "react-js-pagination";
import { dataIsAvailable, dateFormat } from "utils";
import { Input, TextArea } from "components/Form";
import {
    addFreeCourseAccess,
    getDeviceLogListViaStudentEmail,
    getdetailsofstudentViaStudentEmailorphone,
} from "services/student/studentController";
// import CourseModal from "./Sections/CourseModal";
import ModalBox from "components/modal/ModalBox";
import {
    Checkbox,
    IconButton,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import CommentBankIcon from "@mui/icons-material/CommentBank";
import Paper from "@mui/material/Paper";
// import CommentRow from "./CommentRow";
import { useSearchParams } from "react-router-dom";
// import BulkCourseModal from "./Sections/BulkCourseModal";
import { getSignedUrl } from "services/master";
import { getDeviceIDLogReport } from "services/reports/reportController";
import * as XLSX from "xlsx";
import { lime } from "@mui/material/colors";

const DeviceIDLogReport = () => {
    const [searchParam, setSearchParam] = useSearchParams();
    const [activePage, setActivePage] = useState(1);
    let search = searchParam.get("query") || "";

    const [submitButtonElement, setSubmitLoading] = useMuiButtonLoader();
    const [submitButtonElement2, setSubmitLoading2] = useMuiButtonLoader();
    const [userEmail, setUserEmail] = useState(search || "");
    const [selectedCourseId, setSelectedCourseId] = useState("");
    const [userData, setUserData] = useState({});

    const [courseModal, setCourseModal] = useState(false);
    const [bulkAssignModal, setBulkAssignModal] = useState(false);
    const [confirmModal, setConfirmModal] = useState(false);
    const [revokeModal, setRevokeModal] = useState(false);
    const [commentModal, setCommentModal] = useState(false);
    const [comment, setComment] = useState("");
    const [commentError, setCommentError] = useState("");
    const [allComments, setAllComments] = useState([]);
    const [studentDetails, setDeviceIDLogReport] = useState(null);
    const [appliedSearch, setAppliedSearch] = useState("");


    const [record, setRecord] = useState([]);
    const [total, setTotal] = useState(0);
    const [loader, showLoader, hideLoader] = useFullPageLoader();

    const [showMorethanOne, setshowMorethanOne] = useState(false);


    const searchHandler = async (e) => {
        e.preventDefault();

        if (!userEmail) {
            toast.error("Please enter email or phone");
            return;
        }

        setActivePage(1);              // RESET TO PAGE 1
        setAppliedSearch(userEmail);   // STORE SEARCH
    };

    React.useEffect(() => {
        fetchDeviceLogs(
            appliedSearch,
            showMorethanOne ? "morethanone" : undefined
        );
        // eslint-disable-next-line
    }, [activePage, appliedSearch, showMorethanOne]);





    const fetchDeviceLogs = async (searchValue = "", type) => {
        try {
            showLoader();
            const finalData = {
                page: activePage,
                stype: type,
                ...(searchValue ? { search: searchValue } : {})
            };

            const res = await getDeviceIDLogReport(finalData);
            hideLoader();

            if (res.code === 200) {
                setRecord(res.data.deviceLogreport.rows || []);
                setTotal(res.data.deviceLogreport.count || 0);
            } else {
                toast.error(res.message);
                setRecord([]);
            }
        } catch (err) {
            hideLoader();
            toast.error(err?.response?.data?.message || err.message);
        }
    };




    //*********Handel Pagination********* */
    const handlePageChange = (event) => {
        searchParam.set("page", event);
        setSearchParam(searchParam);
    };


    const resetFilter = () => {
        setUserEmail("");        // Clear input
        setAppliedSearch("");    // Clear applied search
        setActivePage(1);        // Reset page
    };

    const downloadExcelHandler = async (searchValue = "") => {
        if (searchValue && typeof searchValue !== "string") {
            searchValue = "";
        }

        setSubmitLoading2(true);
        showLoader();

        const finalData = {
            page: 1,
            limit: 10000000,
            type: "excel",
            stype: showMorethanOne ? "morethanone" : undefined,
            ...(searchValue ? { search: searchValue } : {})
        };

        const res = await getDeviceIDLogReport(finalData);
        hideLoader();
        setSubmitLoading2(false);

        if (res.code === 200) {
            const data = res.data.deviceLogreport.rows.map((row, i) => ({
                "S.NO": i + 1,
                "Student Name": `${row.FirstName} ${row.LastName}`,
                "EmailID": row.EmailID || "",
                "Mobile": row.Mobile || "",
                "Platform": row.platform || "",
                "DeviceID": row.deviceid || "",
                "Last Used On": row.addedon ? dateFormat(row.addedon) : "",
            }));

            const wb = XLSX.utils.book_new();
            const ws = XLSX.utils.json_to_sheet(data);
            XLSX.utils.book_append_sheet(wb, ws, "DeviceLogs");
            XLSX.writeFile(wb, "DeviceIDLog.xlsx");
        } else {
            toast.error(res.message);
        }
    };




    return (
        <React.Fragment>
            <title>Shubhra Viraj | Device ID Log Report</title>
            <div className="">
                <div className="WrapperBox">
                    <div className="Small-Wrapper">
                        <div className="search_wrap">
                            <div className="SearchBox"></div>
                            <h4 className="Title">Device ID Log Report</h4>
                        </div>
                        <div className=" mt-3">
                            <form onSubmit={searchHandler}>
                                <div className="row w-100">
                                    <div className={`col-form-label py-0 col-sm-7`}>
                                        <Input
                                            className={"form-control"}
                                            placeholder="Enter User Email Address or Phone or Device ID"
                                            value={userEmail}
                                            onChange={({ target }) => setUserEmail(target.value)}
                                            type="text"
                                        />
                                    </div>

                                    <div className="col-sm-5 d-flex justify-content-left gap-3">
                                        <Button type="submit" {...submitButtonElement}>
                                            Search
                                        </Button>
                                        <Button
                                            className="refresh_btnn"
                                            onClick={resetFilter}
                                            style={{
                                                height: "42px",
                                                width: "42px",
                                            }}
                                        >
                                            <i className="fa fa-refresh"></i>
                                        </Button>
                                        {/* <Button
                                            onClick={() => downloadExcelHandler(appliedSearch)}
                                            {...submitButtonElement2}
                                        >
                                            Export to Excel
                                        </Button> */}

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="Small-Wrapper" style={{ marginTop: "10px" }}>
                        {record && record.length > 0 ? (
                            <div className="row mt-3" >
                                <div className="col-sm-12">
                                    <div className="TableList overflow-auto table-responsive" style={{ paddingTop: "0px" }}>
                                        {/* <table className="position-relative"> */}
                                        <div className="d-flex align-items-center mb-2">
                                            {/* LEFT */}
                                            <h4 className="mb-0">
                                                Device ID Log (Total Records {total})
                                            </h4>

                                            {/* RIGHT */}
                                            <div className="d-flex align-items-center ms-auto gap-4">
                                                <div className="d-flex align-items-center">
                                                    <Checkbox
                                                        sx={{
                                                            transform: "scale(1.2)",
                                                            "& .MuiSvgIcon-root": { fontSize: 20, color: "#4971b2" },
                                                            padding: 0,
                                                        }}
                                                        checked={showMorethanOne}
                                                        onChange={(e) => {
                                                            setActivePage(1); // reset pagination
                                                            setshowMorethanOne(e.target.checked);
                                                        }}

                                                    />
                                                    <span style={{ marginLeft: "8px" }}>
                                                        Mutiple DeviceID's
                                                    </span>
                                                </div>

                                                <Button
                                                    onClick={() => downloadExcelHandler(appliedSearch)}
                                                    {...submitButtonElement2}
                                                >
                                                    Export to Excel
                                                </Button>
                                            </div>
                                        </div>


                                        <table className="table table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>S.no</th>
                                                    <th>Student Name</th>
                                                    <th>EmailID</th>
                                                    <th>Mobile</th>
                                                    <th>Platform</th>
                                                    <th>Device ID</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {record.length > 0 ? (
                                                    record.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>{(activePage - 1) * 10 + index + 1}</td>
                                                            <td>{item.FirstName} {item.LastName}</td>
                                                            <td>{item.EmailID}</td>
                                                            <td>{item.Mobile}</td>
                                                            <td>{item.platform}</td>
                                                            <td>{item.deviceid}</td>
                                                            <td>{dateFormat(item.addedon)}</td>
                                                        </tr>
                                                    ))
                                                ) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-center">
                                                            No record found
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>

                                        </table>
                                    </div>
                                    {total > 10 ? (
                                        <div className="Pagination my-2">
                                            <Pagination
                                                activePage={activePage}
                                                itemsCountPerPage={10}
                                                totalItemsCount={total}
                                                pageRangeDisplayed={5}
                                                onChange={(page) => setActivePage(page)}
                                            />

                                        </div>
                                    ) : null}

                                </div>
                            </div>
                        ) : (
                            <NotFound cols={5} />
                        )}


                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default DeviceIDLogReport;
